import { Injectable } from "@angular/core";
import { TableRow } from "../../models/common-table";

@Injectable({
  providedIn: "root",
})
export class CommonTableStateService {
  public getCurrentPage(rows: TableRow[], pageNumber: number, pageSize: number): TableRow[] {
    const pageStartIndex: number = pageNumber * pageSize;
    const pageEndIndex: number = pageStartIndex + pageSize;
    return rows.slice(pageStartIndex, pageEndIndex);
  }

  public normalizePageNumber(pageNumber: number, pageSize: number, totalRows: number): number {
    if (pageSize <= 0) {
      return 0;
    }

    const totalPages: number = Math.ceil(totalRows / pageSize);
    if (pageNumber >= totalPages) {
      return Math.max(0, totalPages - 1);
    }

    return Math.max(0, pageNumber);
  }

  public areAllRowsSelected(rows: TableRow[]): boolean {
    return !rows.some((row: TableRow) => {
      return row.find((cell) => cell?.data)?.data?.["$Selected"] !== true;
    });
  }
}
